import { createSlice, nanoid } from '@reduxjs/toolkit';

const initialState = {
  items: [],
};

const toastSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    addToast: {
      reducer: (state, action) => {
        state.items.unshift(action.payload);
        state.items = state.items.slice(0, 4);
      },
      prepare: ({ title, message, type = 'notification', refNo, duration = 6000 }) => ({
        payload: {
          id: nanoid(),
          title,
          message,
          type,
          refNo,
          duration,
          createdAt: Date.now(),
        },
      }),
    },
    removeToast: (state, action) => {
      state.items = state.items.filter((toast) => toast.id !== action.payload);
    },
    clearToasts: (state) => {
      state.items = [];
    },
  },
});

export const { addToast, removeToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
